import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { toast, Bounce } from "react-toastify";
import "./accordoQuadro.css";
import CustomSelect from "../CustomSelect";
import useTrainerSearch from "../hooks/useTrainerSearch";

const AddAccordoQuadro = () => {
  const [trainerCodiceFiscale, setTrainerCodiceFiscale] = useState("");
  const [dataAccordo, setDataAccordo] = useState("");
  const [tipologiaAccordo, setTipologiaAccordo] = useState("");
  const [dataProssimoAggiornamento, setDataProssimoAggiornamento] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [inputErrors, setInputErrors] = useState({});
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const loadTrainerOptions = useTrainerSearch();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per modificare!");
      navigate("/login");
      localStorage.clear();
    } else {
      setIsAuthorized(true);
    }
  }, [navigate]);

  const tipologiaOptions = [
    { value: "Standard", label: "Standard" },
    { value: "Speciale", label: "Speciale" },
  ];

  const isValid = () => {
    const errors = {};
    if (!trainerCodiceFiscale) {
      errors.trainerCodiceFiscale = "Seleziona un trainer!";
    }
    if (!dataAccordo) {
      errors.dataAccordo = "Data Accordo non può essere vuota!";
    }
    if (!tipologiaAccordo) {
      errors.tipologiaAccordo = "Tipologia Accordo non può essere vuota!";
    } else if (
      !tipologiaOptions.some((opt) => opt.value === tipologiaAccordo)
    ) {
      errors.tipologiaAccordo = "Valore non valido per Tipologia Accordo!";
    }
    if (!dataProssimoAggiornamento) {
      errors.dataProssimoAggiornamento =
        "Data Prossimo Aggiornamento non può essere vuota!";
    }
    setInputErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!isValid()) return;

    setLoading(true);
    try {
      const response = await api.post("/accordo-quadro", {
        trainerCodiceFiscale: trainerCodiceFiscale.trim(),
        dataAccordo,
        tipologiaAccordo,
        dataProssimoAggiornamento,
      });
      if (response.status === 200) {
        toast.success("Accordo Quadro creato con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setSelectedTrainer(null);
        navigate("/accordo-quadro");
      }
    } catch (error) {
      console.error("Errore nel salvataggio dell'accordo quadro:", error);

      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">
          <i className="fa-solid fa-file-contract"></i>
          Aggiungi Accordo Quadro
        </div>
        <div className="controls">
          <button
            onClick={() => navigate("/accordo-quadro")}
            className="back-btn"
          >
            <i className="fa-solid fa-arrow-left"></i>
            Torna agli Accordi
          </button>
        </div>
      </div>

      <div className="page-content add-accordo">
        <div className="form-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-handshake"></i>
              Dettagli Accordo Quadro
            </div>
            <div className="card-subtitle">
              Compila i campi per creare un nuovo accordo quadro con un trainer
            </div>
          </div>

          <div className="card-content">
            <div className="form-grid">
              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-user-tie"></i>
                  Docente
                  <span className="required">*</span>
                </label>
                <div className="form-input">
                  <CustomSelect
                    loadOptions={loadTrainerOptions}
                    value={selectedTrainer}
                    onChange={(selected) => {
                      setSelectedTrainer(selected);
                      const codiceFiscale =
                        selected?.trainer?.codiceFiscale ||
                        selected?.value ||
                        "";
                      setTrainerCodiceFiscale(codiceFiscale);
                      setInputErrors((prev) => {
                        const updated = { ...prev };
                        delete updated.trainerCodiceFiscale;
                        return updated;
                      });
                    }}
                    placeholder="Seleziona un docente"
                    className="modern-select"
                  />
                  {inputErrors.trainerCodiceFiscale && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {inputErrors.trainerCodiceFiscale}
                    </span>
                  )}
                  {error && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {error}
                    </span>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-calendar-alt"></i>
                  Data Accordo
                  <span className="required">*</span>
                </label>
                <div className="form-input">
                  <input
                    id="dataAccordo"
                    type="datetime-local"
                    value={dataAccordo}
                    onChange={(e) => {
                      const val = e.target.value;
                      setDataAccordo(val);
                      setInputErrors((prev) => {
                        const updated = { ...prev };
                        if (val) {
                          const today = new Date().toISOString().split("T")[0];
                          if (val <= today) delete updated.dataAccordo;
                        }
                        return updated;
                      });
                    }}
                    className="modern-input"
                  />
                  {inputErrors.dataAccordo && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {inputErrors.dataAccordo}
                    </span>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-tag"></i>
                  Tipologia Accordo
                  <span className="required">*</span>
                </label>
                <div className="form-input">
                  <CustomSelect
                    options={tipologiaOptions}
                    value={
                      tipologiaAccordo
                        ? tipologiaOptions.find(
                            (opt) => opt.value === tipologiaAccordo
                          )
                        : null
                    }
                    onChange={(selected) => {
                      const val = selected ? selected.value : "";
                      setTipologiaAccordo(val);
                      if (val.trim()) {
                        setInputErrors((prev) => {
                          const updated = { ...prev };
                          delete updated.tipologiaAccordo;
                          return updated;
                        });
                      }
                    }}
                    placeholder="Seleziona tipologia accordo"
                    className="modern-select"
                  />
                  {inputErrors.tipologiaAccordo && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {inputErrors.tipologiaAccordo}
                    </span>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-calendar-plus"></i>
                  Data Prossimo Aggiornamento
                  <span className="required">*</span>
                </label>
                <div className="form-input">
                  <input
                    id="dataProssimoAggiornamento"
                    type="date"
                    value={dataProssimoAggiornamento}
                    onChange={(e) => {
                      const val = e.target.value;
                      setDataProssimoAggiornamento(val);
                      setInputErrors((prev) => {
                        const updated = { ...prev };
                        if (val) {
                          const today = new Date().toISOString().split("T")[0];
                          if (val <= today)
                            delete updated.dataProssimoAggiornamento;
                        }
                        return updated;
                      });
                    }}
                    className="modern-input"
                  />
                  {inputErrors.dataProssimoAggiornamento && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {inputErrors.dataProssimoAggiornamento}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button
                className="btn-secondary"
                onClick={() => navigate("/accordo-quadro")}
              >
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button className="btn-primary" onClick={handleSubmit}>
                <i className="fa-solid fa-save"></i>
                Crea Accordo Quadro
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAccordoQuadro;
